import { Routes } from '@angular/router';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { NonEmployeeComponent } from './shared/components/non-employee/non-employee.component';
import { LoginFailedService } from './shared/services/login-failed/login-failed.guard.service';
import { LoginFailedComponent } from './shared/components/login-failed/login-failed.component';
import { HomePageComponent } from './modules/home/components/home-page/home-page.component';
import { VaccinationVerificationsComponent } from './modules/home/components/vaccination-verifications/vaccination-verifications.component';
import { DocumentUploadComponent } from './modules/home/components/documents/documents.component';
import { SetAdditionalInfoComponent } from './modules/home/components/set-additional-info/set-additional-info.component';
import { AuthComponent } from './modules/auth/auth.component';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'home',
    component: HomePageComponent,
    children: [
      {
        path: '',
        component: VaccinationVerificationsComponent,
      },
      {
        path: 'documents',
        component: DocumentUploadComponent,
      },
      {
        path: 'info/:id',
        component: SetAdditionalInfoComponent,
      },
      {
        path: ':token',
        component: HomePageComponent,
      },
    ],
    canActivate: [authGuard],
  },
  {
    path: 'admin',
    loadComponent: () => import('./modules/admin/components/admin-page/admin-page.component').then((m) => m.AdminPageComponent),
    canActivate: [authGuard, adminGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./modules/admin/components/admin-table/admin-table.component').then((m) => m.AdminTableComponent),
      },
    ],
  },
  {
    path: 'alfred',
    loadComponent: () => import('./modules/admin/components/alfred/alfred.component').then((m) => m.AlfredComponent),
  },
  {
    path: 'login',
    component: LoginFailedComponent,
    canActivate: [LoginFailedService],
  },
  {
    path: 'flu-portal-login-redirect',
    component: AuthComponent,
  },
  {
    path: 'non-employee',
    component: NonEmployeeComponent,
    canActivate: [authGuard],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
